import { Grid } from "@mui/material";
import { EnumAutocomplete } from "components/alove/EnumAutocomplete";
import { Group, GroupType } from "models/profile/Group";

const MDInput = require("components/MDInput").default;

export const EditGroupForm = ({
  group,
  setGroup,
}: {
  group: Group;
  setGroup: (group: Group) => void;
}) => {
  return (
    <Grid container spacing={2}>
      <Grid size={6}>
        <MDInput
          label="Group Name"
          fullWidth
          value={group.name || ""}
          onChange={(e) => setGroup(Object.assign(new Group(), group, { name: e.target.value }))}
        />
      </Grid>
      <Grid size={6}>
        <EnumAutocomplete
          enumName={GroupType}
          value={group.type || GroupType.Inclusive}
          onChange={(value) => setGroup(Object.assign(new Group(), group, { type: value }))}
        />
      </Grid>
      <Grid size={12}>
        <MDInput
          label="Description"
          fullWidth
          multiline
          rows={3}
          value={group.description || ""}
          onChange={(e) => setGroup(Object.assign(new Group(), group, { description: e.target.value }))}
        />
      </Grid>
    </Grid>
  );
}; 